import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import bytes from 'bytes';
/** Number value for bytes or string value for kb/mb/gb etc. */ export const formatFileSize = (value, options)=>bytes(value, _object_spread({
        unitSeparator: ' '
    }, options));
